import React from "react"
import { Text } from "react-native"

const Separator = () => (
  <Text importantForAccessibility="no-hide-descendants">{" · "}</Text>
)

export default Separator
